import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ThemeProvider, CssBaseline } from '@mui/material';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import * as hu from 'i18n/hu.json';
import * as en from 'i18n/en.json';
import router from 'router';
import * as yup from 'yup';
import { initYup } from 'forms/CustomValidators';
import { GlobalToast } from 'components/GlobalToast/GlobalToast';
import { LocalizationProvider } from '@mui/x-date-pickers';
import './styles.css';
import useThemeSwitch from 'hooks/useThemeSwitch';
import { getTheme } from 'theme';
import moment from 'moment';

// add extra validations to yup
initYup(yup);

// initialize translations
i18n
  .use(initReactI18next)
  .init({
    resources: {
      hu: {
        translation: hu,
      },
      en: {
        translation: en,
      },
    },
    lng: localStorage.getItem('language') ?? 'hu',
    fallbackLng: 'hu',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    console.log('i18n initialized');
  });

// Sets Monday as the first day of the week for Hungarian locale.
moment.updateLocale('hu', {
  week: { dow: 1 },
});

export default function App() {
  const mode = useThemeSwitch();
  const { i18n } = useTranslation();
  const theme = getTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <CssBaseline />
        <GlobalToast />
        <LocalizationProvider key={i18n.language} adapterLocale={i18n.language} dateAdapter={AdapterMoment}>
          <RouterProvider router={router} />
        </LocalizationProvider>
      </RecoilRoot>
    </ThemeProvider>
  );
}
